var map = {
	"./icons/badgeacademician.png": 1290,
	"./icons/badgecitizen.png": 9755,
	"./icons/badgeexpat.png": 9443,
	"./icons/badgenomad.png": 7192,
	"./icons/badgetourist.png": 7656,
	"./icons/vocabularycount.png": 483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;